import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "a603e1a9-315e-40b7-a02d-ed86c2c16612",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "ab35d76d-f3e4-4091-a178-5e94011d6fe5",
      type: "Text",
      name: "amount",
      nameSpace: "",
      className: "",
      x: 57,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "500",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 56,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#712006",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "a603e1a9-315e-40b7-a02d-ed86c2c16612",
      data: ""
    },
    {
      id: "92210bb4-4221-4737-8999-0a8390552289",
      type: "Sprite",
      name: "reward",
      nameSpace: "",
      className: "prizes",
      x: -43,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hud_level_joker",
      parent: "a603e1a9-315e-40b7-a02d-ed86c2c16612",
      data: ""
    }
  ]
} as const;

export class StandardWheelRewardLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  amount: GameObject<PIXI.Text>;
  reward: GameObject<PIXI.Sprite>;
  prizes: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
